import { RANK_THRESHOLDS } from "../../lib/constants";

function getProgress(points) {
  for (let i = 0; i < RANK_THRESHOLDS.length; i++) {
    if (points >= RANK_THRESHOLDS[i].min) {
      if (i === 0) return { pct: 100, label: "Max rank" };
      const currentMin = RANK_THRESHOLDS[i].min;
      const nextMin = RANK_THRESHOLDS[i - 1].min;
      const nextRank = RANK_THRESHOLDS[i - 1].rank;
      const earned = points - currentMin;
      const needed = nextMin - currentMin;
      const pct = Math.min((earned / needed) * 100, 100);
      return {
        pct,
        label: `${earned}/${needed} to ${nextRank.charAt(0).toUpperCase() + nextRank.slice(1)}`,
      };
    }
  }
  return { pct: 0, label: "" };
}

export default function RankProgressBar({ points }) {
  const { pct, label } = getProgress(points);

  return (
    <div className="mt-1.5">
      <div className="h-1.5 rounded-full bg-stone/30 overflow-hidden">
        <div
          className="h-full rounded-full bg-terracotta transition-all duration-700 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      {label && (
        <span className="text-[10px] text-walnut-light mt-0.5 block">{label}</span>
      )}
    </div>
  );
}
